import { render, staticRenderFns } from "./AmountViewer.vue?vue&type=template&id=147b451e&scoped=true"
import script from "./AmountViewer.vue?vue&type=script&lang=js"
export * from "./AmountViewer.vue?vue&type=script&lang=js"
import style0 from "./AmountViewer.vue?vue&type=style&index=0&id=147b451e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147b451e",
  null
  
)

export default component.exports